<template>
    <div>
        <form
            class="hero-block-inner__form form-account"
            @submit.prevent="submit"
        >
            <div class="form-account__title">Sign Up</div>

            <v-text-field
                v-model="model.firstName"
                v-validate="'required'"
                prepend-inner-icon="person"
                name="firstName"
                :label="$t('fields.firstName')"
                type="firstName"
                :data-vv-as="$t('fields.firstName')"
                :error-messages="errors.collect('firstName')"
                persistent-placeholder
                outlined
            />

            <v-text-field
                v-model="model.lastName"
                v-validate="'required'"
                prepend-inner-icon="person"
                name="lastName"
                :label="$t('fields.lastName')"
                type="lastName"
                :data-vv-as="$t('fields.lastName')"
                :error-messages="errors.collect('lastName')"
                outlined
                persistent-placeholder
            />

            <v-text-field
                v-model="model.email"
                v-validate="'required|email'"
                prepend-inner-icon="mail"
                persistent-placeholder
                name="email"
                :label="$t('fields.email')"
                type="email"
                :data-vv-as="$t('fields.email')"
                :error-messages="errors.collect('email')"
                outlined
            />

            <v-text-field
                v-model="model.phone"
                v-validate="{ required: !model.cellPhone }"
                prepend-inner-icon="phone"
                name="phone"
                :label="$t('fields.phone')"
                type="phone"
                :data-vv-as="$t('fields.phone')"
                :error-messages="errors.collect('phone')"
                outlined
                persistent-placeholder
            />

            <v-text-field
                v-model="model.cellPhone"
                v-validate="{ required: !model.phone }"
                prepend-inner-icon="phone"
                name="cellPhone"
                :label="$t('fields.cellPhone')"
                type="cellPhone"
                :data-vv-as="$t('fields.cellPhone')"
                :error-messages="errors.collect('cellPhone')"
                outlined
                persistent-placeholder
            />

            <v-text-field
                ref="password"
                v-model="model.password"
                v-validate="{
                    required: true,
                    min: 8,
                    max: 24,
                    verifyPassword: true,
                }"
                prepend-inner-icon="lock"
                name="password"
                :label="$t('fields.password')"
                :data-vv-as="$t('fields.password')"
                :error-messages="errors.collect('password')"
                outlined
                :append-icon="visibility ? 'visibility' : 'visibility_off'"
                :type="visibility ? 'text' : 'password'"
                persistent-placeholder
                @click:append="() => (visibility = !visibility)"
            />

            <v-text-field
                v-model="model.confirmPassword"
                v-model.lazy="model.passwordConfirmation"
                v-validate="{
                    required: true,
                    min: 8,
                    max: 24,
                    is: model.password,
                    verifyPassword: true,
                }"
                prepend-inner-icon="lock"
                name="confirmPassword"
                :label="$t('fields.confirmPassword')"
                :data-vv-as="$t('fields.confirmPassword')"
                :error-messages="errors.collect('confirmPassword')"
                outlined
                :append-icon="visibility ? 'visibility' : 'visibility_off'"
                :type="visibility ? 'text' : 'password'"
                persistent-placeholder
                @click:append="() => (visibility = !visibility)"
            />

            <div class="form-account__row form-row">
                <button type="submit" class="form-row__submit">Sign up</button>
            </div>
            <div class="form-account__text">
                Already have an account?
                <router-link class="form-account__link" to="/account/sign-in"
                    >Sign in</router-link
                >
                or
                <router-link
                    class="form-account__link"
                    to="/account/reset-password"
                    >Reset password</router-link
                >
            </div>
        </form>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    export default {
        $_veeValidate: {
            validator: 'new',
        },
        data() {
            return {
                model: {
                    email: '',
                    password: '',
                    confirmPassword: '',
                    firstName: '',
                    lastName: '',
                    phone: '',
                    cellPhone: '',
                },
                sitekey: '6Ld07wAVAAAAAOByK2gQhD8OGuAAS4vxWU-EX61l',
                visibility: false,
            };
        },
        methods: {
            ...mapActions('auth', ['registration']),

            /**
             * Create user and redirect to confirmation registration page
             */
            async submit(resp) {
                if (!resp) return;
                const validation = await this.$validator.validateAll();
                if (!validation) return;

                this.registration(this.model);
            },
        },
    };
</script>

<style scoped lang="stylus">
    @import '../assets/styles/pages/account';
</style>
